// extracted by mini-css-extract-plugin
export var deliveryRow = "_k1-a";
export var fixedHeight = "_k1-4";
export var freightLogo = "_k1-9";
export var fullWidth = "_k1-3";
export var priceColumn = "_k1-5";
export var radioSelected = "_k1-7";
export var radioUnselected = "_k1-6";
export var selectedOption = "_k1-2";
export var selectedOptionContainer = "_k1-1";
export var selection = "_k1-0";
export var tallSkeletonText = "_k1-8";